<template>
	<div>
		<div class="home">
			<div class="background">
				<!-- <div class="gradient-bg"></div>
				<div class="gradient-bg2"></div> -->
				<div class="light-effect light-1"></div>
				<div class="light-effect light-2"></div>
				<div class="light-effect light-3"></div>
			</div>
			<div class="content">
				<div class="mainArea">
					<div class="bigTitle wow bounceInLeft" data-wow-duration="1s" style="margin-top: 80px;">优质<label>内容</label>
					</div>
					<div class="bigTitle wow bounceInLeft" data-wow-duration="1s" style="margin-left: 120px;"><label>创新</label>科技
					</div>
					<div class="bigTitle2 wow fadeInDownBig">重塑消费娱乐体验</div>
					<div class="item3Box wow fadeIn">
						<div class="light-effect light-1"></div>
						<div class="img3Box">
							<img src="../../assets/home_1.jpg" @click="goto(2)" />
							<div class="imgBox2">
								<img src="../../assets/home_2.jpg" @click="goto(1)" />
								<img src="../../assets/home_3.jpg" @click="goto(3)" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<floating-ad  v-if="adVisible" :speed="speed" @flagClick="flagClick" @close="closeAd"></floating-ad>
	</div>
</template>

<script>
	import floatingAd from '../../compenents/advants.vue'
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'Home',
		components: {
			floatingAd
		},
		data() {
			return {
				adVisible: true,
				speed: 1,
				// 调整点25: 添加可视区域尺寸跟踪
				viewportWidth: window.innerWidth,
				viewportHeight: window.innerHeight
			}
		},		
		created() {
			let isM = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if (isM) {
				this.$router.push({
					path: '/mobile/home'
				});
			}
		},
		beforeDestroy() {
			// 调整点28: 移除事件监听
			window.removeEventListener('resize', this.updateViewportSize);
		},
		methods: {
			goto(type) {
				this.$router.push({
					path: '/pc/business?demoType=' + type
				});
			},
			
			flagClick(){				
				this.$router.push({
					path: '/pc/cinema'
				});
			},
			// 调整点32: 添加关闭广告方法
			closeAd() {
				this.adVisible = false;
			},
			
			// 调整点34: 添加更新可视区域尺寸方法
			updateViewportSize() {
				this.viewportWidth = window.innerWidth;
				this.viewportHeight = window.innerHeight;
			}
		},
		mounted() {
			// 调整点27: 添加窗口大小变化监听
			window.addEventListener('resize', this.updateViewportSize);
			this.$nextTick(() => {
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		}
	}
</script>
<style lang="less" scoped>
	.item3Box {
		position: relative;
		overflow: hidden;
		margin-top: 100px;
		margin-left: -10px;
		margin-right: -10px;

		.light-1 {
			z-index: -1;
			position: absolute;
			width: 1000px;
			height: 1000px;
			border-radius: 50%;
			filter: blur(80px);
			animation: moveAround 10s linear infinite;
			background: rgba(106, 0, 255, 0.1);
			top: -600px;
			left: 15%;
			animation-delay: 0s;
		}

		.b {
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			margin-top: 0px !important;
			margin-bottom: 0px !important;
		}
	}

	.imgBox {
		background: #fff;
		border-radius: 8px;
		margin: 20px;
		width: calc((100vw - 280px)/2 - 40px);

		img {
			width: 100%;
			height: auto;
			border-radius: 8px 8px 0 0;
		}

	}

	.img3Box {
		display: flex;
		margin: 0 auto;
		gap: 20px;

		/* 图片间距 */
		.imgBox2 {
			flex: 1;
			display: flex;
			flex-direction: column;
			gap: 20px;
			/* 右侧两张图的间距 */
		}

		img {
			flex: 1;
			width: 100%;
			height: 100%;
			object-fit: cover;
			/* 保持比例填充容器 */
			border-radius: 4px;
		}
	}

	.background {
		position: absolute;
		background: url('../../assets/homeBg.jpg') no-repeat;
		background-size: 100% 100%;
		top: -200px;
		left: 0;
		width: 100%;
		//height: 100vh;
		height: calc(100vh + 200px);
		z-index: 1;
		overflow: hidden;
	}

	.gradient-bg {
		position: absolute;
		width: 200%;
		height: 300%;
		top: -80%;
		left: -50%;
		opacity: 0.8;
		background: linear-gradient(135deg, rgba(106, 0, 255, 1) 35%, #0066c5 60%, #a200ff 80%, #c300ff 100%);
		animation: rotate 10s ease-in-out infinite, colorShift 20s alternate infinite;
		transform-origin: center;
	}

	.light-effect {
		position: absolute;
		width: 800px;
		height: 800px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 25s linear infinite;
	}

	.light-1 {
		background: rgba(106, 0, 255, 0.2);
		top: 20%;
		left: 30%;
		animation-delay: 0s;
	}

	.light-2 {
		background: rgba(195, 0, 255, 0.2);
		bottom: 10%;
		right: 20%;
		animation-delay: -10s;
		animation-duration: 10s;
	}

	.light-3 {
		background: rgba(162, 0, 255, 0.3);
		top: 60%;
		left: 10%;
		width: 400px;
		height: 400px;
		animation-delay: -5s;
		animation-duration: 20s;
	}

	.particle {
		position: absolute;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.1);
		animation: float 15s infinite ease-in-out;
	}

	@keyframes rotate {
		0% {
			transform: rotate(0deg) scale(1);
		}

		50% {
			transform: rotate(180deg) scale(1.1);
		}

		100% {
			transform: rotate(360deg) scale(1);
		}
	}

	@keyframes colorShift {
		0% {
			filter: hue-rotate(0deg) brightness(1);
		}

		100% {
			filter: hue-rotate(20deg) brightness(1.1);
		}
	}

	@keyframes moveAround {
		0% {
			transform: translate(0, 0);
		}

		25% {
			transform: translate(100px, -80px);
		}

		50% {
			transform: translate(-60px, 70px);
		}

		75% {
			transform: translate(80px, 100px);
		}

		100% {
			transform: translate(0, 0);
		}
	}

	@keyframes float {

		0%,
		100% {
			transform: translateY(0) translateX(0);
			opacity: 0.7;
		}

		50% {
			transform: translateY(-50px) translateX(40px);
			opacity: 0.9;
		}
	}


	.bigTitle {
		font-size: 120px;
		letter-spacing: 0.02em;
		font-weight: 800;
		text-shadow: 0 4px 30px rgba(0, 0, 0, 0.45);

		label {
			color: #ff791f
		}
	}

	.bigTitle2 {
		font-size: 100px;
		font-weight: 1;
		margin-top: 60px;
	}

	.home {
		position: relative;
		padding-top: -80px;
	}

	/* 内容演示区：不影响背景，只用来可视化 */
	.content {
		position: relative;
		z-index: 2;
		margin-bottom: 50px;
	}

	@media (max-width:1440px) {
		.imgBox {
			background: #fff;
			width: calc((100vw - 80px)/2 - 10px);
		}

		.bigTitle {
			font-size: 80px;
		}

		.bigTitle2 {
			font-size: 60px;
		}
	}

	@media (max-width:800px) {
		.bigTitle {
			font-size: 60px;
		}

		.bigTitle2 {
			font-size: 40px;
		}

		.background {
			height: 100vh;
		}

		.item3Box {
			margin-top: 50px;
		}
	}
</style>